import React, { useContext, useEffect, useState } from 'react';
import { Table, Pagination } from 'react-bootstrap';
import Eye from "../../Assets/icons/Eye.svg";
import { UserContext } from '../../Context/UserContext';
import { User } from '../../interface';
import { useNavigate } from "react-router-dom";
import Paginated from '../../Components/Pagination';

interface UserTabProps {
  searchTerm: string;
}

const UserTab: React.FC<UserTabProps> = ({ searchTerm }) => {
  const navigate = useNavigate();
  const { getAllUserData } = useContext(UserContext);
  const [usersData, setUsersData] = useState<User[]>([]);
  const [currentPage, setCurrentPage] = useState(1);
  const [totalPages, setTotalPages] = useState(0);

  const getData = async (page = 1, term = '') => {
    const response = await getAllUserData(page, term);
    setUsersData(response.data);
    setTotalPages(response.totalPages);
  };

  useEffect(() => {
    getData(currentPage, searchTerm);
  }, [currentPage, searchTerm]);

  function viewAs(okta_id: string,name:string): void {
    localStorage.setItem('userView', okta_id)
    localStorage.setItem('nameView', name)
    localStorage.setItem('viewAss', 'true')
    navigate("/home");
  }

  const handlePageChange = (pageNumber: number) => {
    setCurrentPage(pageNumber);
  };

  return (
    <div>
      <div className='shadow p-4'>
        <Table hover>
          <thead>
            <tr>
              <th>Views as</th>
              <th>Client ID</th>
              <th>Account Name</th>
              <th>User Name</th>
              <th>Email</th>
              <th>Qlik Rol</th>
            </tr>
          </thead>
          <tbody>
            {usersData.map((user) => (
              <tr key={user.id}>
                <td className='text-center cursor-pointer'>
                  <div onClick={() => viewAs(user.okta_id, user.user_firstname)}>
                    <img src={Eye} alt="View" width={20} />
                  </div>
                </td>
                <td>{user.account.huspot_id}</td>
                <td>{user.account.institution_name}</td>
                <td>{user.user_firstname}</td>
                <td>{user.user_email}</td>
                <td>{user.qlikRole.qlik_role_description}</td>
              </tr>
            ))}
          </tbody>
        </Table>
        <Paginated currentPage={currentPage} totalPages={totalPages} onPageChange={handlePageChange} />
      </div>
    </div>
  );
};

export default UserTab;
